import { Logger } from "../utils/logger.util";
import { Resolver } from "../types";
export class IdResolver extends Resolver {
    constructor(options) {
        super();
        this.options = options;
        if (typeof this.options.logger !== "boolean") {
            this.logger = new Logger(Object.assign(Object.assign({}, this.options.logger), { name: `${Object.getPrototypeOf(this).constructor.typeName()}` }));
        }
        else {
            this.logger = new Logger();
        }
    }
}
//# sourceMappingURL=index.js.map